module.exports = __webpack_public_path__ + "static/media/global-rank-intro.882be74f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global-rank-intro.svg
// module id = 153
// module chunks = 0